import { Rotate as Hamburger } from "hamburger-react";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import {
  itemVariants,
  sideVariants,
} from "../../common/data/animation/MobileMenu.animation";
import { links } from "../../common/data/Links/Navbar.links";
import { useTranslation } from "react-i18next";

const MobileMenu = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation(["common"]);

  return (
    <>
      <div className="xl:hidden flex text-yellow-800 pr-4">
        <Hamburger toggled={isOpen} toggle={setOpen} />
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.aside
            className="bg-white rounded-lg fixed top-[4.6rem] z-10 right-2 w-72 xl:hidden flex shadow-xl shadow-gray-100 border border-gray-100"
            initial={{ height: 0 }}
            animate={{
              height: 320,
            }}
            exit={{
              transition: { delay: 0.7, duration: 1 },
            }}
          >
            <div className="fixed rounded-lg bg-white border-t w-7 h-7 top-16 right-6 rotate-45"></div>
            <motion.div
              className="w-full"
              initial="closed"
              animate="open"
              exit="closed"
              variants={sideVariants}
            >
              {links.map((item, key) => (
                <motion.a
                  key={key}
                  href={item.to}
                  whileHover={{ translateX: 5 }}
                  variants={itemVariants}
                  className="flex items-center px-5 py-3 space-x-3 hover:bg-yellow-50 w-full"
                >
                  <div className="bg-yellow-100 text-yellow-600 text-lg w-10 h-10 flex items-center justify-center rounded-lg">
                    {item.icon}
                  </div>
                  <div className="text-lg text-yellow-800">{t(item.name)}</div>
                </motion.a>
              ))}
            </motion.div>
          </motion.aside>
        )}
      </AnimatePresence>
    </>
  );
};

export default MobileMenu;
